module.exports = "/_next/static/images/img_yellow_sprite.MUMVtUxq.png";